import { createBrowserRouter } from 'react-router-dom';

import { AuthGuard } from './components/auth/AuthGuard';
import { RootLayout } from './components/layout/RootLayout';
import { About } from './pages/About';
import { AdminAuditLog } from './pages/admin/AuditLog';
import { AdminDocuments } from './pages/admin/Documents';
import { AdminRecordsRequests } from './pages/admin/RecordsRequests';
import { AdminUsers } from './pages/admin/Users';
import { ConfirmEmailChange } from './pages/auth/ConfirmEmailChange';
import { ConfirmPasswordReset } from './pages/auth/ConfirmPasswordReset';
import { ConfirmVerification } from './pages/auth/ConfirmVerification';
import { Board } from './pages/Board';
import { ChangePassword } from './pages/ChangePassword';
import { Contact } from './pages/Contact';
import { Documents } from './pages/Documents';
import { Gallery } from './pages/Gallery';
import { Home } from './pages/Home';
import { InsuranceCertificate } from './pages/InsuranceCertificate';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { Portal } from './pages/Portal';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'about', element: <About /> },
      { path: 'board', element: <Board /> },
      { path: 'documents', element: <Documents /> },
      { path: 'gallery', element: <Gallery /> },
      { path: 'contact', element: <Contact /> },
      { path: 'insurance-certificate', element: <InsuranceCertificate /> },
      { path: 'login', element: <Login /> },
      // PB sends email links to these branded landings instead of its own
      // Studio UI under /_/#/auth/... — see meta/template patches in PB.
      { path: 'auth/confirm-verification/:token', element: <ConfirmVerification /> },
      { path: 'auth/confirm-password-reset/:token', element: <ConfirmPasswordReset /> },
      { path: 'auth/confirm-email-change/:token', element: <ConfirmEmailChange /> },
      {
        path: 'change-password',
        element: (
          <AuthGuard allowPasswordChangePending>
            <ChangePassword />
          </AuthGuard>
        ),
      },
      {
        path: 'portal',
        element: (
          <AuthGuard>
            <Portal />
          </AuthGuard>
        ),
      },
      {
        path: 'admin/documents',
        element: (
          <AuthGuard requireRole={['admin', 'super_admin']}>
            <AdminDocuments />
          </AuthGuard>
        ),
      },
      {
        path: 'admin/records-requests',
        element: (
          <AuthGuard requireRole={['admin', 'super_admin']}>
            <AdminRecordsRequests />
          </AuthGuard>
        ),
      },
      {
        path: 'admin/audit-log',
        element: (
          <AuthGuard requireRole={['admin', 'super_admin']}>
            <AdminAuditLog />
          </AuthGuard>
        ),
      },
      {
        path: 'admin/users',
        element: (
          <AuthGuard requireRole={['admin', 'super_admin']}>
            <AdminUsers />
          </AuthGuard>
        ),
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
